import { Citation } from 'redux/modules/citation-module';

export const isCitationEmpty = (citation: Citation): boolean => {
  if (citation) {
    return Object.keys(citation.data).length <= 2;
  }
  return false;
};
